import { motion } from "framer-motion";
import {
    GraduationCap,
    Compass,
    Rocket,
    Laptop,
    Megaphone,
    BookOpen,
} from "lucide-react";
import SectionHeading from "./SectionHeading";

const PERSONAS = [
    {
        icon: GraduationCap,
        title: "Students",
        text: "Affordable books for studies, placements & new skills.",
    },
    {
        icon: Compass,
        title: "Job Seekers",
        text: "Crack interviews with career & communication guides.",
    },
    {
        icon: Rocket,
        title: "Entrepreneurs",
        text: "Learn business, sales & growth from the best minds.",
    },
    {
        icon: Laptop,
        title: "Freelancers",
        text: "Win better clients with marketing & productivity books.",
    },
    {
        icon: Megaphone,
        title: "Marketers",
        text: "SEO, ads & copywriting playbooks that actually work.",
    },
    {
        icon: BookOpen,
        title: "Lifelong Learners",
        text: "A personal library that never stops growing.",
    },
];

export default function WhoFor() {
    return (
        <section
            data-testid="who-is-this-for-section"
            className="bg-white py-16 sm:py-24"
        >
            <div className="mx-auto max-w-7xl px-4 sm:px-6">
                <SectionHeading
                    eyebrow="Who is this for"
                    title="Made for curious minds on a budget"
                />
                <div className="mt-10 grid grid-cols-2 gap-3 sm:gap-5 lg:grid-cols-3">
                    {PERSONAS.map(({ icon: Icon, title, text }, i) => (
                        <motion.div
                            key={title}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, amount: 0.3 }}
                            transition={{ duration: 0.5, delay: (i % 3) * 0.08 }}
                            data-testid="persona-card"
                            className="rounded-2xl border border-emerald-100 bg-white p-5 shadow-soft transition-all duration-300 hover:-translate-y-1 hover:shadow-lift sm:p-6"
                        >
                            <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-emerald-50 text-emerald-600">
                                <Icon size={19} />
                            </span>
                            <h3 className="mt-3 font-display text-sm font-bold text-slate-900 sm:text-lg">
                                {title}
                            </h3>
                            <p className="mt-1 text-xs leading-relaxed text-slate-500 sm:text-sm">
                                {text}
                            </p>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
